var _circle, _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVoice = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#455CC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70089 4.37061C5.54135 4.01641 5.37363 4.00826 5.22227 4.00419C5.09955 4.00012 4.95637 4.00012 4.8132 4.00012C4.67002 4.00012 4.44094 4.05305 4.24458 4.26476C4.04822 4.47647 3.50006 4.98945 3.50006 6.03578C3.50006 7.07804 4.26503 8.08773 4.37139 8.23023C4.47775 8.37272 5.84816 10.5835 8.01217 11.4344C9.81211 12.1428 10.1803 12.0003 10.5689 11.9636C10.9575 11.927 11.8289 11.4506 12.0088 10.9539C12.1847 10.4572 12.1847 10.0338 12.1316 9.94425C12.0784 9.85468 11.9352 9.80176 11.7225 9.6959C11.5098 9.59005 10.4625 9.07706 10.2662 9.00378C10.0698 8.93457 9.92665 8.89792 9.78756 9.10963C9.64439 9.32134 9.23531 9.79769 9.11259 9.94018C8.98986 10.0827 8.86305 10.099 8.65033 9.99311C8.43761 9.88725 7.75036 9.66333 6.9363 8.93864C6.30223 8.37679 5.8727 7.6806 5.74998 7.46889C5.62726 7.25718 5.73771 7.14318 5.84407 7.03733C5.93815 6.94369 6.05679 6.78898 6.16315 6.66684C6.26951 6.5447 6.30632 6.45513 6.37587 6.31263C6.44541 6.17014 6.41268 6.048 6.3595 5.94214C6.30632 5.84036 5.88907 4.78996 5.70089 4.37061Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVoice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/voice.b9581bcc.svg";
export { ForwardRef as ReactComponent };